"use client";
import { Button, buttonVariants } from "@repo/ui/components/ui/button";
import { useTranslations } from "next-intl";
import Icon from "@repo/ui/components/ui/icon/icon";
import { type VariantProps } from "class-variance-authority";
import { useRegistration } from "@/hooks/useRegistration";

export default function SignIn({
  buttonVariant,
  buttonText,
}: {
  buttonVariant?: VariantProps<typeof buttonVariants>["variant"];
  buttonText?: string;
}) {
  const t = useTranslations();
  const { signInAction } = useRegistration();

  return (
    <div className="flex gap-5">
      <Button
        variant={buttonVariant || "outline"}
        className="sign-in"
        onClick={() => signInAction()}
      >
        <span className="max-md:hidden">{buttonText || t("signin")}</span>
        <Icon
          icon="AccountCircle"
          className="h-[24px] w-[24px] hidden max-md:block"
        />
      </Button>
      <Button
        variant="default"
        className="sign-in max-md:hidden"
        onClick={() => signInAction(true)}
      >
        {t("register")}
      </Button>
    </div>
  );
}
